/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const ClipBoardCheckSolid = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M14.3998 2.3999C15.2886 2.3999 16.0648 2.88365 16.4773 3.5999H16.7998C18.1236 3.5999 19.1998 4.67615 19.1998 5.9999V19.1999C19.1998 20.5237 18.1236 21.5999 16.7998 21.5999H7.1998C5.87605 21.5999 4.7998 20.5237 4.7998 19.1999V5.9999C4.7998 4.67615 5.87605 3.5999 7.1998 3.5999H7.5223C7.9348 2.88365 8.71105 2.3999 9.5998 2.3999H14.3998ZM15.4086 10.3724C15.0073 10.0799 14.4448 10.1699 14.1523 10.5712L10.9423 14.9849L9.94855 13.9574C9.60355 13.6012 9.03355 13.5899 8.6773 13.9349C8.32105 14.2799 8.3098 14.8499 8.6548 15.2062L10.3948 17.0062C10.5786 17.1974 10.8373 17.2987 11.1036 17.2799C11.3698 17.2612 11.6136 17.1262 11.7711 16.9124L15.6073 11.6287C15.8998 11.2274 15.8098 10.6649 15.4086 10.3724ZM9.8998 4.7999C9.40105 4.7999 8.9998 5.20115 8.9998 5.6999C8.9998 6.19865 9.40105 6.5999 9.8998 6.5999H14.0998C14.5986 6.5999 14.9998 6.19865 14.9998 5.6999C14.9998 5.20115 14.5986 4.7999 14.0998 4.7999H9.8998Z"
        fill="white"
      />
    </BaseSvgIcon>
  )
}

export default ClipBoardCheckSolid
